import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from '../firebase-config';
import axios from '../api/axios';
import { showToast } from '../utils/toastHelper';
import { useRefresh } from '../contexts/RefreshContext';

const useFcmToken = () => {
    const { triggerRefresh } = useRefresh();

    useEffect(() => {
        const updateTokenInBackend = async (token) => {
            try {
                await axios.post('/auth/update-fcm-token', {
                    fcm_token: token
                });
                console.log('FCM Token updated in backend');
            } catch (error) {
                console.error('Error updating FCM token in backend:', error);
            }
        };

        const permissionRequest = async () => {
            try {
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                    // Get Token
                    const currentToken = await getToken(messaging, {
                        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
                    });

                    if (currentToken) {
                        console.log('FCM Token:', currentToken);
                        // Send token to backend
                        await updateTokenInBackend(currentToken);
                    } else {
                        console.log('No registration token available. Request permission to generate one.');
                    }
                } else {
                    console.log('Unable to get permission to notify.');
                }
            } catch (err) {
                console.log('An error occurred while retrieving token. ', err);
            }
        };

        permissionRequest();

        // Handle incoming messages in foreground
        const unsubscribe = onMessage(messaging, (payload) => {
            console.log('Message received. ', payload);
            
            // Trigger global data refresh
            triggerRefresh();

            if (payload.data?.type === 'notify') {
                // Play notification sound
                try {
                    const audio = new Audio('/notification-sound.wav');
                    audio.volume = 0.7;
                    audio.play().catch(err => console.log('Sound play failed:', err));
                } catch (e) {
                    console.log('Sound init failed:', e);
                }
                showToast('info', `${payload.data.title}: ${payload.data.body}`);
            }
        });

        return () => unsubscribe();
    }, [triggerRefresh]);
};

export default useFcmToken;
